module.exports = __webpack_public_path__ + "static/media/userSquare.eaeae64a.svg";